import { useCallback, useState, useId } from 'react';
import classNames from 'classnames';
import { CheckIcon } from 'app/agriculture/icons';

import './AgCheckbox.scss';

interface CheckboxProps {
    id: string;
    onChange: (checked: boolean) => void;
    defaultChecked?: boolean;
    disabled?: boolean;
    label?: string;
    // if you need to drive the checkbox state, use the below
    isChecked?: boolean;
    className?: string;
}

export function AgCheckbox({
    id,
    onChange,
    label,
    isChecked,
    defaultChecked = false,
    disabled = false,
    className,
}: CheckboxProps) {
    const [checked, setChecked] = useState(defaultChecked);
    const isCheckedSet = isChecked !== undefined;
    const labelId = useId();

    if (isCheckedSet && defaultChecked) {
        console.warn(
            'Looks like you are using AgCheckbox with both a default value and' +
                " externally driving the checked state. This probably won't work how you expect. ",
        );
    }

    const handleClick = useCallback(() => {
        if (isCheckedSet) {
            onChange(!isChecked);
        } else {
            setChecked((checked) => {
                onChange(!checked);
                return !checked;
            });
        }
    }, [onChange, isChecked]);

    return (
        <button
            type="button"
            className={classNames(className, 'AgCheckbox', {
                'AgCheckbox--checked': isCheckedSet ? isChecked : checked,
            })}
            aria-labelledby={labelId}
            data-testid={`AgCheckbox--${id}`}
            onClick={handleClick}
            disabled={disabled}
        >
            <div className="AgCheckbox__input">
                <input
                    id={id}
                    data-testid={id}
                    type="checkbox"
                    checked={isCheckedSet ? isChecked : checked}
                    onChange={handleClick}
                    disabled={disabled}
                />
                <div className="AgCheckbox__icon">
                    <CheckIcon size={15} strokeWidth={1} />
                </div>
            </div>
            {!!label && (
                <label id={labelId} className="AgCheckbox__label" data-testid="AgCheckbox__label">
                    {label}
                </label>
            )}
        </button>
    );
}
